export default {
  breakBorder: '1px solid var(--sg-grey-200)',
};
